import React from 'react';
import { reduxForm } from 'redux-form';

const formComponents = {};
export const getFormComponent = (formName) => {
  if (!formComponents[formName]) {
    const component = ({ children }) => <div>{children}</div>; // eslint-disable-line
    formComponents[formName] = reduxForm({
      form: formName,
      destroyOnUnmount: false,
    })(component);
  }
  return formComponents[formName];
};
